import { render } from "./App.vue?vue&type=template&id=3de31063&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3de31063&scoped=true&lang=css"

import exportComponent from "G:\\VUE\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de31063"]])

export default __exports__